import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';

import * as utils from '@services/utils/common';

import type { IHeadRow, IRow } from '@typings';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'TimelineTopOverlay',
},
  __name: 'TimelineTopOverlay',
  props: {
    heads: {},
    list: {},
    beforeHeight: {},
    recycler: {}
  },
  setup(__props: any, { expose: __expose }) {



const props = __props;

const text = ref(String());

function refresh() {
  text.value = getText() ?? String();
}

function getText() {
  if (!props.recycler?.$el || !props.list.length) return;

  // Read the scroll position of the recycler (layout).
  const scrollTop = props.recycler.$el.scrollTop;

  // Still over the before slot: nothing to show.
  if (scrollTop < props.beforeHeight) return;

  // Row at the top edge (offsets exclude the before slot).
  const topRowIdx = props.recycler.findItemIndex(scrollTop - props.beforeHeight);
  const topRow = props.list[topRowIdx];
  if (!topRow) return;

  // A visible header needs no overlay.
  if (topRow.type === 0) return;

  // Avoid barely-visible rows, must have minimum height.
  const belowIdx = props.recycler.findItemIndex(50 + scrollTop - props.beforeHeight);
  const belowRow = props.list[belowIdx];
  if (belowRow?.dayId !== topRow.dayId) return;

  // Do not show overlay for single-row days.
  const head = props.heads.get(topRow.dayId);
  if (!head || (head.day?.rows?.length ?? 0) <= 1) {
    return;
  }

  return utils.getHeadRowName(head);
}

__expose({ refresh });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["top-overlay", { show: !!text.value }])
  }, _toDisplayString(text.value), 3))
}
}

})